package com.milta.feature.admin.presentation

import com.milta.feature.admin.domain.entity.AdminPrompt

/** State for the Admin "Prompts" screen (read-only contract footer, editable body only). */
data class AdminPromptsState(
    val isLoading: Boolean = true,
    val prompts: List<AdminPrompt> = emptyList(),
    /** "server_error" | "offline". */
    val error: String? = null,
    val selectedKey: String? = null,
    /** Live editor text per prompt key — diverges from the matching [prompts] entry's `body`
     * while the Admin is typing; a key's draft equaling its saved body means "not dirty". Seeded
     * from the loaded prompt and overwritten on save/reset so Save/Reset always compare against
     * the latest server state, not a stale load. */
    val drafts: Map<String, String> = emptyMap(),
    /** Keys currently showing the rendered preview instead of the editor. */
    val previewKeys: Set<String> = emptySet(),
    val savingKeys: Set<String> = emptySet(),
    /** "server_error" | "offline", keyed by prompt — a save/reset failure on one prompt must not
     * block switching to another tab. */
    val actionErrors: Map<String, String> = emptyMap(),
)
